import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import {
  TargetingSettingsContext,
  getNameForRadiusLocation,
} from '@bingads-webui-campaign/targeting-settings-scaffolds';
import locationsColumnTemplate from './target.pug';

export class ColumnLocations extends CampaignuiBaseColumn {
  constructor({
    i18n,
  }) {
    const localizedTitle = i18n.getString('CampaignSettingsGrid_ColumnHeader_Locations');

    super({
      name: 'Locations',
      type: 'string',
      property: ['Id', 'CampaignCriterions', 'RecommendationTypes', 'TotalCountOfLocationTargets', 'TotalCountOfExcludedLocationTargets'],
      sortable: false,
      title: 'CampaignSettingsGrid_ColumnHeader_Locations',
      helpId: 'Page_CampaignGrids_Locations',
      i18n,
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: localizedTitle }),
    });

    this.i18n = i18n;
  }

  template({ value }) {
    const cid = TargetingSettingsContext.state.get('customer_id');
    const aid = TargetingSettingsContext.state.get('account_id');
    const link = `/campaign/vnext/settings?aid=${aid}&cid=${cid}&campaignId=${value.cmpid}`;
    return locationsColumnTemplate({
      link,
      name: value.locationName,
      hasLocationRecommendation: value.hasLocationRecommendation,
      i18n: this.i18n,
      campaignId: value.cmpid,
    });
  }

  get property() {
    return {
      get: ({
        Id,
        TotalCountOfLocationTargets,
        TotalCountOfExcludedLocationTargets,
        CampaignCriterions,
        RecommendationTypes = [],
      }) => {
        const criterions = _.chain(CampaignCriterions)
          .filter(criterion => criterion.Criterion.Type === 'Location' || criterion.Criterion.Type === 'Radius')
          .pluck('Criterion')
          .value();

        const names = [];
        _.each(criterions, (c) => {
          if (_.isEmpty(c.Name)) {
            names.push(getNameForRadiusLocation(c.Latitude, c.Longitude));
          } else {
            names.push(c.Name);
          }
        });

        let displayName;
        if (_.isEmpty(names) || names.length === 0) {
          displayName = this.i18n.getString('CampaignImport_AllTargetLocations');
        } else {
          const combinedName = names.join(', ');
          if (TotalCountOfLocationTargets > names.length) {
            displayName = `${combinedName} ${this.i18n.getString('CampaignImport_And')} ${TotalCountOfLocationTargets - names.length} ${this.i18n.getString('AllSettings_More')}`;
          } else {
            displayName = combinedName;
          }
        }

        if (TotalCountOfExcludedLocationTargets > 0) {
          displayName = `${displayName} ${this.i18n.getString('AllSettings_ExcludedCount').replace('{count}', TotalCountOfExcludedLocationTargets)}`;
        }

        return {
          cmpid: Id,
          locationName: displayName,
          hasLocationRecommendation: _.contains(RecommendationTypes, 'NewLocationTarget'),
        };
      },
      key: this.config.property,
    };
  }
}
